import { fetchRequest } from "@providers/conect";

const verCitaExtraApi = async ( data ) => {
  try {
    const url = `agendawp/view`
    const response = await fetchRequest(url, {
      method: "POST",
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { verCitaExtraApi };
